/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import LeftArrowIcon from 'material-ui-icons/ArrowBack';
import RightArrowIcon from 'material-ui-icons/ArrowForward';
import EventIcon from 'material-ui-icons/Event';
import {
    handlecheckInChangeFactory, handlecheckOutChangeFactory,
    handleNightsChangeFactory, handleNightsEnterFactory
} from '../Utils/FilterChangeFunctions';
import moment from 'moment';

import Room from './Room';
import { translate } from 'react-i18next';
import { Grid, TextField, CircularProgress } from 'material-ui';
import { handleSubmitFactory, componentDidMountFactory } from './CommonFunctions';

import AbstractSearchForm from './AbstractSearchForm';
import { MenuItem } from 'material-ui';
import { DatePicker } from 'material-ui-pickers';
import { getForm } from './ExclusiveSearchForms/ExclusiveSearchFormFactory';
import { Button } from 'material-ui';
import { Typography } from 'material-ui';


const styles = {
    avatar: {
        backgroundColor: 'dark-grey',
        color: 'grey',
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    roomNumberTextField: {
        width: '140px',
        marginBottom: '32px',
    },
    footNoteText: {
        marginTop: '16px',
        fontWeight: 300,
        paddingTop: 0
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '24px'
    }
};

const roomsValues = Array.from(Array(6).keys());
roomsValues.shift();

/**
 * Componente de busqueda destinos Exclusive
 *
 * @author Luciano Bustos
 */
class ExclusiveForm extends AbstractSearchForm {
    constructor(props) {
        super(props);

        const { user, classes, accountName } = props;
        this.accountName = accountName ? accountName : 'default';
        this.state = this.initState(classes);
        this.ExclusiveFormFTS = getForm(this.accountName);
    }

    componentDidMount = () => {
        //super.componentDidMount();
        componentDidMountFactory(this)();
    }

    handleFault = error => {
        alert(error.message);
    }

    initState = (classes, eroskiData) => {
        return {
            classes: classes,
            inputError: false,
            totalRooms: 1,
            rooms: [
                {
                    adults: 2,
                    kids: [],
                    mealPlan: 'ALL',
                },
            ],
            checkOut: moment(this.START_DAY).add(1, 'days'),
            checkIn: moment(this.START_DAY),
            nights: 1,
            value: '',
            suggestions: [],
            selectedSuggestion: {},
            loading: false,

            hasExclusiveForm: true,
            exclusiveFormSelected: true,
            exclusiveDestinationSelected: null,
            data: eroskiData || [],
        };
    };

    handleClose = () => {
        this.props.onClose(this.state);
    };

    handleCancel = () => {
        this.props.onClose(null);
    };

    render() {
        const { classes, t, isDisabled } = this.props;
        const ExclusiveFormFTS = this.ExclusiveFormFTS;
        return (
            <div className="SearchForm">
                <table width="100%" className="cmsExclusiveForms cmsTable">
                    <tbody>
                        <tr>
                            <td colSpan="4">
                                {ExclusiveFormFTS ?
                                    <ExclusiveFormFTS
                                        parent={this}
                                        accountName={this.accountName}
                                        exclusiveDestinations={this.state.data}
                                        width='100%'
                                        hide={false}
                                    />
                                    : ''}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <DatePicker
                                    keyboard
                                    label={t('COMMON.CHECK_IN')}
                                    format={'DD/MM/YYYY'}
                                    autoOk fullWidth
                                    className="cmsFormContainer"
                                    leftArrowIcon={<LeftArrowIcon />}
                                    rightArrowIcon={<RightArrowIcon />}
                                    disablePast
                                    InputLabelProps={{
                                        className: classes.inputLabelDate,
                                    }}
                                    keyboardIcon={
                                        <EventIcon />
                                    }
                                    value={this.state.checkIn}
                                    onChange={handlecheckInChangeFactory(this)}
                                    animateYearScrolling={false}
                                    disabled={this.state.loading}
                                    minDateMessage={t('HOME.DATE_VALIDATION')}
                                    invalidDateMessage={t('HOME.INVALID_FORMAT')}
                                />
                            </td>
                            <td className="cmsSearchNight">
                                <TextField
                                    label={t('COMMON.NIGHTS')}
                                    className="cmsFormContainer"
                                    value={this.state.nights}
                                    onChange={handleNightsChangeFactory(this)}
                                    onBlur={(e) => { handleNightsEnterFactory(e, this); }}
                                    onKeyDown={(e) => { handleNightsEnterFactory(e, this); }}
                                    type="number"
                                    inputProps={{ min: 1, max: this.MAX_NIGHTS }}
                                    disabled={this.state.loading}
                                />
                            </td>
                            <td>
                                <DatePicker
                                    keyboard
                                    label={t('COMMON.CHECK_OUT')}
                                    format={'DD/MM/YYYY'}
                                    autoOk
                                    fullWidth
                                    className="cmsFormContainer"
                                    leftArrowIcon={<LeftArrowIcon />}
                                    rightArrowIcon={<RightArrowIcon />}
                                    disablePast
                                    InputLabelProps={{
                                        className: classes.inputLabelDate,
                                    }}
                                    keyboardIcon={
                                        <EventIcon />
                                    }
                                    value={this.state.checkOut}
                                    onChange={handlecheckOutChangeFactory(this)}
                                    animateYearScrolling={false}
                                    disabled={this.state.loading}
                                    minDateMessage={t('HOME.DATE_VALIDATION')}
                                    invalidDateMessage={t('HOME.INVALID_FORMAT')}
                                />
                            </td>
                            <td className="cmsSearchRooms">
                                <TextField
                                    select
                                    label={t('COMMON.ROOMS')}
                                    name={'totalRooms'}
                                    fullWidth
                                    value={this.state.totalRooms}
                                    className="cmsFormContainer"
                                    onChange={this.handleTotalRoomChange}
                                    InputLabelProps={{
                                        className: classes.inputLabel,
                                    }}
                                    SelectProps={{
                                        MenuProps: {
                                            className: classes.menu,
                                        },
                                    }}
                                    disabled={this.state.loading}>
                                    {roomsValues.map(option => (
                                        <MenuItem key={option} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </TextField>

                            </td>
                        </tr>
                    </tbody>
                </table>
                {this.state.rooms.map((r, number) => (
                    <Room
                        key={number}
                        displayIcon={true}
                        displayTitle={true}
                        loading={this.state.loading}
                        number={number}
                        {...r}
                        handleAdultChange={this.handleAdultChange}
                        handleKidsChange={this.handleKidsChange}
                        handleKidsAgeChange={this.handleKidsAgeChange}
                    />
                ))}
                <Grid container justify="space-between" alignItems="center">
                    <Grid item xs={6}>
                        <Typography className="caption">{t('HOME.BABIES_AS_CHILDREN')}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Button
                            variant="raised"
                            color="secondary"
                            onClick={() => { handleSubmitFactory(this)(); }}
                            //disabled={this.state.loading}
                            size={'large'}
                            fullWidth
                            disabled={isDisabled}
                            className="cmsButtonSearch">
                            {this.state.loading && <CircularProgress size={24} />}
                            {t('HOME.SEARCH_BUTTON')}
                        </Button>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

ExclusiveForm.propTypes = {
    classes: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    accountName: PropTypes.string.isRequired,
    nights: PropTypes.number.isRequired,
    onClose: PropTypes.func,
};
export default translate('translations')(withStyles(styles)(ExclusiveForm));


// WEBPACK FOOTER //
// ./src/components/SearchContent/ExclusiveForm.js